export const fileFrCATranslations = {
  fileAccepted: "Formats acceptés : {{types}}",
  fileMaxSize: "Jusqu’à {{size}} Mo",
  fileMaxSizeEach: "Jusqu’à {{size}} Mo chacun",
  fileMaxFiles: "{{count}} fichiers maximum",
  fileChooseOneHead: "Choisissez un fichier",
  fileChooseManyHead: "Choisissez des fichiers",
  fileDragTail: "ou glissez-déposez",
  fileUpload: "Téléverser",
  fileAnyOne: "N’importe quel fichier",
  fileAddMany: "Ajoutez un ou plusieurs fichiers",
  fileReplace: "Remplacer le fichier",
  fileRemove: "Retirer {{name}}",
  fileCurrent: "Fichier actuel",
  fileUploading: "Téléversement… {{percent}} %",
  fileUploadFailed: "Échec du téléversement.",
  fileUploadOffline:
    "Désolé, ce fichier n’a pas pu être téléversé, car la connexion a été perdue. Vérifiez votre connexion et réessayez.",
  fileErrorMaxOne: "1 fichier maximum.",
  fileErrorMaxMany: "{{count}} fichiers maximum.",
  fileErrorTooLarge: "« {{name}} » dépasse la limite de {{size}} Mo.",
  fileErrorType:
    "« {{name}} » n’est pas un type de fichier accepté. Formats acceptés : {{types}}.",
  fileSelected: "Fichier sélectionné : {{name}}",
  filesSelected: "{{count}} fichiers sélectionnés",
  fileProgress: "Téléversement de {{name}} : {{percent}} %",
  fileComplete: "{{name}} téléversé",
  fileFailed: "Échec du téléversement de {{name}} : {{reason}}",
  fileTriggerName: "{{label}} : {{prompt}}",
  fileRemoved: "{{name}} retiré",
};
